class MoneyService {
  public round(value: number): number {
    if (!Number.isFinite(value)) return 0;

    const rounded = Math.sign(value) * Math.round((Math.abs(value) + Number.EPSILON) * 100) / 100;

    return Object.is(rounded, -0) ? 0 : rounded;
  }

  public payable(value: number): number {
    const rounded = this.round(value);

    return rounded > 0 ? rounded : 0;
  }

  public isPayable(value: number): boolean {
    return this.payable(value) > 0;
  }
}

export default new MoneyService();
